<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="lg"
    :modal-title="`팝업 수정`"
    :confirm="save"
    :close="close"
    confirmButtonTitle="저장"
    name="popupModal"
  >
    <b-container>
      <b-row>
        <b-col>
          <b-form-floating-label>
            타이틀
          </b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model="title"
            type="text"
            required
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row v-if="type === 'UNLOCK_POPUP'" class="my-2">
        <b-col>
          <b-form-floating-label>수업 접근 코드</b-form-floating-label>
          <b-form-input
            v-model="lessonAccessCode"
            rows="3"
            max-rows="6"
            required
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-floating-label>팝업 내용</b-form-floating-label>
          <b-form-textarea
            v-model="content"
            rows="3"
            max-rows="6"
            required
          ></b-form-textarea>
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "PopupModal",
  components: {AdminModal},
  props: ['isOpen', 'popupInfo', 'reload', 'close'],
  data() {
    return {
      type : "",
      title : "",
      content: "",
      lessonAccessCode: null
    }
  },
  mounted() {
    this.type = this.popupInfo.type
    this.title = this.popupInfo.title
    this.content = this.popupInfo.content
    this.lessonAccessCode = this.popupInfo.lessonContentAccessCode
  },
  methods: {
    save() {
      api.lesson.patchPopupInfo({
        id: this.popupInfo.id,
        title: this.title,
        content: this.content,
        lessonAccessCode: this.lessonAccessCode
      }, _ => {
        this.reload()
        this.close()
      })
    }
  }
}
</script>

<style scoped>

</style>